import { Outlet } from "react-router";
import { InitializationStateComponent } from "@/init/initialization-state-component";
import { ModalProvider } from "@/components/modal-popup/modal-popup";
import CustomToast from "@/components/custom-toast/custom-toast";
import Footer from "@/components/footer/footer-view";

export default function RootLayout() {
  return (
    <div className="root-container">
      <InitializationStateComponent>
        <ModalProvider>
          <main className="page-container">
            <Outlet />
            <Footer />
          </main>
          <CustomToast />
        </ModalProvider>
      </InitializationStateComponent>
    </div>
  );
}
